import { Box, Grid, Typography } from "@mui/material";
import StringHelper from "../../helpers/string.helper";
import { EntityStatistics } from "../../interfaces/EntityStatistics";
import classes from './SitesStatistic.module.scss';

const SitesStatistic = ({ data }: { data: EntityStatistics[] }) => {

  return <Box>
    <Typography className={`${classes['label']} mb-3 fs-5`} >
      Original Articles Per Site
    </Typography>
    <Grid container spacing={2}>
      {data.map((site) => (
        <Grid item key={StringHelper.generateRandomString(9)} xs={12} sm={6} md={4}>
          <Box className='d-flex justify-content-between border light-boxed p-4'>
            <Typography className={classes['name-label']} alignSelf='center' >
              {site.name}
            </Typography>
            <Typography className={classes['count-label']} alignSelf='center' >
              {site.count}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
}

export default SitesStatistic;
